import { OverlayProvider } from "@saviynt/design-system";
import { ReactNode } from "react";
import { QueryProvider } from "./QueryProvider";
import { IntlProvider } from "react-intl";
import { AuthProvider } from "../../contexts/AuthContext";
import { ThemeProvider } from "../../contexts/ThemeContext";
import enMessagesRaw from "../../locales/en.json";

interface ProvidersProps {
  children: ReactNode;
}

// Extract only defaultMessage strings from the messages object
const enMessages = Object.entries(enMessagesRaw).reduce(
  (acc, [key, value]) => {
    acc[key] = (value as { defaultMessage: string }).defaultMessage;
    return acc;
  },
  {} as Record<string, string>,
);

const messages = {
  en: enMessages,
};

export function Providers({ children }: ProvidersProps) {
  return (
    <ThemeProvider>
      <OverlayProvider>
        <IntlProvider locale="en" messages={messages.en} defaultLocale="en">
          <QueryProvider>
            <AuthProvider>{children}</AuthProvider>
          </QueryProvider>
        </IntlProvider>
      </OverlayProvider>
    </ThemeProvider>
  );
}
